const getters = {
  lang: (state)=> state.lang.lang,
  cWidth: (state)=> state.client.cWidth,
  config: (state)=> state.config.config
}
export default getters